module.exports = __webpack_public_path__ + "static/energy_15-22da4305db41c8b3815716b4cf7b202e.jpg";